export namespace STQueryCoreActions {
  export class TransitoryFetchSTQueries {
    static readonly type = '[ST Query Core] TransitoryFetch Statistic Queries';
    constructor(public payload: { entityId: string; excludedIds?: string[] }) {}
  }
}
